import React from 'react';
import { withRouter, RouteComponentProps } from 'react-router';
import { injectIntl, InjectedIntlProps } from 'react-intl';
import { compose } from 'react-apollo';
import GraphQLClient from '@api/graphql/GraphQLClient';
import * as Mutations from '@api/graphql/mutations';
import * as Queries from '@api/graphql/queries';
import { PromotionPlace, updateProductCategoryVariables, PromotionCategory, PromotionCategory_adminProductCategoryById_products_data } from '@api/graphql/types';
import PromotionPlaceSelector from '../components/PromotionCategorySelector';
import { connect } from 'react-redux';
import { ApplicationState } from 'reducers/';
import ProductInput, { ProductIdName } from '../components/ProductInput';
import Form from '@components/Form/Form';
import Env from '@root/utils/Env';

type Props = {
    promotionCategoryId: string;
} & InjectedIntlProps & RouteComponentProps<{promotionCategoryId: string}>;


interface State {
    formData: updateProductCategoryVariables;
    products: ProductIdName[];
}

class PromotionCategoryEdit extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);

        this.state = {
            formData: {
                id: props.promotionCategoryId,
                name: '',
                url_key: '',
                content: '',
                is_enable: true,
                date_from: null,
                date_to: null,
                show_in_menu: false,
                keywords: '',
                description: '',
                is_promotion: true,
                promotion_place: PromotionPlace.PROMO_1,
                is_homepage_prohibited: false,
                products: [],
            },
            products: [],
        };
    }

    public componentDidMount() {
        GraphQLClient.query<PromotionCategory>({
            query: Queries.promotionCategory,
            variables: {id: this.props.promotionCategoryId, sortBy: {field: 'SORT', direction: 'ASC'}, count: 1000, page: 1},
        }).then((response) => {
            if (response.data && response.data.adminProductCategoryById) {
                const formData = this.state.formData;
                for (const prop in this.state.formData) {
                    if (formData.hasOwnProperty(prop)) {
                        formData[prop] = response.data.adminProductCategoryById[prop];
                    }
                }
                formData.products = response.data.adminProductCategoryById.products ?
                    response.data.adminProductCategoryById.products.data.map((product: PromotionCategory_adminProductCategoryById_products_data) => product.id) :
                    [];
                const products = response.data.adminProductCategoryById.products ?
                    response.data.adminProductCategoryById.products.data :
                    [];
                this.setState({ formData, products });
            }
        });
    }

    public onSubmit = (variables: updateProductCategoryVariables) => {
        return GraphQLClient.mutate({
            mutation: Mutations.updateProductCategory, variables: this.state.formData,
        });
    }

    private onFormDataChange = (formData: updateProductCategoryVariables) => {
        this.setState({formData});
    }

    private onChange = (value: any, name: keyof updateProductCategoryVariables) => {
        this.setState((prevState) => ({formData: {...prevState.formData, [name]: value}}));
    }

    private changeProducts = (value: ProductIdName[]) => {
        const productIds = value.map((product: ProductIdName) => product.id);
        this.setState((prevState) => ({formData: {...prevState.formData, products: productIds}, products: value}));
    }

    private validate(): boolean {
        return true;
    }

    public render() {
        const PromotionPlaceInput = (
            <PromotionPlaceSelector
                name="promotion_place"
                value={this.state.formData.promotion_place}
                onChange={this.onChange}
                hint={this.props.intl.formatMessage({id: 'module.promotionCategory.promotion_place.hint'})}
            />
        );

        const ProductField = (
            <ProductInput
                name="products"
                value={this.state.products}
                onChange={this.changeProducts}
            />
        );

        const fields = [
            {
                id: 'default',
                fields: [
                    {name: 'name', type:  'text', props: {required: true}},
                    {name: 'url_key', type:  'text', props: { required: true, linkifyHint: true, hint: this.state.formData.url_key ? `${this.props.intl.formatMessage({ id: 'module.promotionCategory.url_key.urlhint' })}: ${Env.webshopUrl}/termekvalogatasok/${this.state.formData.url_key}` : null } },
                    {name: 'content', type:  'markdown', props: {prefix: 'promotions'}},
                    {name: 'date_from', type:  'date'},
                    {name: 'date_to', type:  'date'},
                    {name: 'keywords', type:  'text'},
                    {name: 'description', type:  'text'},
                    {name: 'is_enable', type:  'checkbox'},
                    {name: 'promotion_place', element: PromotionPlaceInput, props: {required: false, alias: ['promotion']}},

                ],
            },
            {
                id: 'products',
                fields: [
                    ProductField,
                ],
            },
        ];

        return (
            <div className="row">
                <div className="col-lg-12">
                    <div className="ibox float-e-margins">
                        <div className="ibox-title">
                            <h5>{this.props.intl.formatMessage({ id: 'module.promotionCategory.edit.title' })}</h5>
                        </div>
                        <div className="ibox-content">
                            <Form
                                intlPrefix={`module.promotionCategory`}
                                fields={fields}
                                formData={this.state.formData}
                                onSubmit={this.onSubmit}
                                validate={this.validate}
                                onChange={this.onFormDataChange}
                            />
                        </div>
                    </div>
                </div>
            </div>

        );
    }
}

const mapStateToProps = (state: ApplicationState, props: Props) => {
    return { promotionCategoryId: props.match.params.promotionCategoryId };
};

export default compose(
    injectIntl,
    withRouter,
    connect(mapStateToProps),
)(PromotionCategoryEdit);



// WEBPACK FOOTER //
// ./src/modules/PromotionCategory/pages/PromotionCategoryEdit.tsx